import { slotDefinition } from "../configs/slotDefinition.config.js";
import { openPopup } from "./helpers/openPopup.js";

export async function betSelect(scope, ctx) {
    const { scenes, gameLogic, hud } = ctx;

    hud.setPopupState();

    const popup = await openPopup(scope, scenes, "BetSettingsScene", {
        betsLadder: slotDefinition.betsLadder,
        bet: gameLogic.bet,
        linesCount: slotDefinition.paylines.length,
    });

    scope.on(popup.onTotalBetChanged, async (totalBet) => {
        await gameLogic.setBet(totalBet);
        hud.setBet(gameLogic.bet);
    });

    await scope.wait(popup.onPressClose);
}
